/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */
/**
 * Remove item that is not a number
 * @param {} rawArr
 */
function filterArray(rawArr) {
  let index = -1;
  const arr_length = rawArr ? rawArr.length : 0;
  let resIndex = -1;
  const result = [];

  while (++index < arr_length) {
    const value = rawArr[index];

    if (value == 0 || value) {
      result[++resIndex] = value;
    }
  }

  return result;
}

/**
   * check if Civil ID is valid
   * @param {} text
   */
function isCorrectCivilID(text) {
  // first validation: check length
  if (text.length != 12) {
    return false;
  }
  // convert from input to array
  const arr = [...text];
  const arrayOfNumbers = arr.map(Number);
  // console.log(arr);
  const newArray = filterArray(arrayOfNumbers);
  //   console.log(`val: ${newArray}`);
  //   console.log(`val: ${arrayOfNumbers}`);
  // second validation: check if user input number only
  if (newArray.length < arrayOfNumbers.length) {
    return false;
  }

  // third validation: specfial rule from Kuwait
  const val = arrayOfNumbers[0] * 2
    + arrayOfNumbers[1] * 1
    + arrayOfNumbers[2] * 6
    + arrayOfNumbers[3] * 3
    + arrayOfNumbers[4] * 7
    + arrayOfNumbers[5] * 9
    + arrayOfNumbers[6] * 10
    + arrayOfNumbers[7] * 5
    + arrayOfNumbers[8] * 8
    + arrayOfNumbers[9] * 4
    + arrayOfNumbers[10] * 2;
  //   console.log(`val: ${val}`);
  //   console.log(`I: ${11 - val % 11}`);
  //   console.log(`II: ${arrayOfNumbers[11]}`);
  if (11 - val % 11 != arrayOfNumbers[11]) {
    return false;
  }
  return true;
}

export default isCorrectCivilID;
//   console.log(isCorrectCivilID('113456789012'));  // true
//   console.log(isCorrectCivilID('113456789013')); // false
